import React from 'react';
import MuiAppBar from '@mui/material/AppBar';
import { useTheme } from './Theming';
import { Grid } from './Grid';
import { IconButton } from './IconButton';
import { MenuIcon } from './Icon';
import { Toolbar } from './Toolbar';
import { styled } from './styled';

import lightLogoFile from './common/mmm-full-logo.png';
import darkLogoFile from './common/mmm-full-logo-darkmode.png';

// webpack compat
const { src: lightLogo = lightLogoFile } = lightLogoFile;
const { src: darkLogo = darkLogoFile } = darkLogoFile;

export { default as AppBar } from '@mui/material/AppBar';

const StyledAppBar = styled(MuiAppBar, {
  shouldForwardProp: (p) => p !== 'enableMobileMenuButton',
})(({ theme, enableMobileMenuButton }) => ({
  '& .MuiToolbar-root': {
    minHeight: '56px',
  },
  '& .logoItem img': {
    height: '52px',
    padding: (enableMobileMenuButton ? '4px 24px 4px 0px' : undefined),
    [theme.breakpoints.up('sm')]: {
      padding: (enableMobileMenuButton ? '4px 24px' : undefined),
    },
  },
  '& .logoItem': {
    lineHeight: 0,
  },
  '& .MuiIconButton-root': {
    margin: '0px',
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
}));

export function LogoBar(props) {
  const {
    enableMobileMenuButton = false,
    handleDrawerToggle,
    children,
    ...otherProps
  } = props;
  const theme = useTheme();
  const logo = theme.palette.mode === 'dark' ? darkLogo : lightLogo;

  return (
    <StyledAppBar enableMobileMenuButton={enableMobileMenuButton} color='default' {...otherProps}>
      <Toolbar disableGutters>
        <Grid container>
          {enableMobileMenuButton && (
            <Grid item>
              <IconButton
                color='inherit'
                aria-label='open drawer'
                edge='start'
                onClick={handleDrawerToggle}
                size='large'
              >
                <MenuIcon />
              </IconButton>
            </Grid>
          )}
          <Grid item className='logoItem'><img src={logo} alt='logo' /></Grid>
          <Grid item xs>
            {children}
          </Grid>
        </Grid>
      </Toolbar>
    </StyledAppBar>
  );
}
